import { AttributeText } from './attribute-text';

export const EmptyValue = () => (
  <AttributeText sx={{ color: 'custom.OV.sys.onBackground' }}>Empty</AttributeText>
);
